//3rd Party Components
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";

const SubModule = ({ name, link, messages, badge, description1, description2, description3, extLink, children }) => {
    let history = useHistory();

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    const msgs = (messages) => {
        return (
            messages.map((item, index) => {
                return (
                    item.msg.level === "error" ?
                        <span key={index} className="badge badge-error">{item.msg.message}</span> :

                        item.msg.level === "warning" ?
                            <span key={index} className="badge badge-warning">{item.msg.message}</span> :

                            item.msg.level === "success" ?
                                <span key={index} className="badge badge-success">{item.msg.message}</span> :

                                item.msg.level === "inprogress" ?
                                    <span key={index} className="badge badge-in-progress">{item.msg.message}</span> :

                                    <span key={index}>{item.msg.message}</span>
                );
            })
        );
    }

    const message = (item) => {
        return (
            item.msg.level === "error" ?
                <span key='1' className="badge badge-error">{item.msg.message}</span> :
                item.msg.level === "warning" ?
                    <span key='1' className="badge badge-warning">{item.msg.message}</span> :
                    item.msg.level === "success" ?
                        <span key='1' className="badge badge-success">{item.msg.message}</span> :
                        item.msg.level === "inprogress" ?
                            <span key='1' className="badge badge-in-progress">{item.msg.message}</span> :
                            <span key='1'>{item.msg.message}</span>
        );
    }

    const handleClick = (link, e) => {
        e.preventDefault();
        //if (e.target.parentElement.tagName === "A") return;
        history.push(link);
    }

    const setName = (name) => {
        return { __html: name };
    }

    const setExtlink = (extLink) => {
        if (extLink) {
            return "casa-external";
        }
        else {
            return "";
        }
    }

    return (
        <div className="casa-dashboard-item col-lg-6 col-md-6 col-xs-12" onClick={(e) => handleClick(link, e)}>
            <h3 className="au-display-sm">
                <a href={link} className={setExtlink(extLink)}>
                    <strong dangerouslySetInnerHTML={setName(name)}></strong>
                </a>
                {badge ? " " + message(badge) : ""}
            </h3>

            {description1 ?
                <Fragment>
                    <span dangerouslySetInnerHTML={setInnerHTML(description1.message)}></span>

                    {description1 && description1.msgsl && description1.msgs.length > 0 ?
                        <span>{message(description1.msgs[0])}</span>
                        : ""}

                </Fragment>
                : ""}
            {description2 ?
                <Fragment>
                    <br/>
                    <span dangerouslySetInnerHTML={setInnerHTML(description2.message)}></span>

                    {description2 && description2.msgs && description2.msgs.length > 0 ?
                        <span>{message(description2.msgs[0])}</span>
                        : ""}

                </Fragment>
                : ""}
            {description3 ?
                <Fragment>
                    <br/>
                    <span dangerouslySetInnerHTML={setInnerHTML(description3.message)}></span>

                    {description3 && description3.msgs && description3.msgs.length > 0 ?
                        <span>{message(description3.msgs[0])}</span>
                        : ""}

                </Fragment>
                : ""}

            {messages ?
                <Fragment>
                    &nbsp;
                    {msgs(messages)}
                </Fragment>
                : ""}

            {children}

        </div>
    );

}

SubModule.defaultProps = {
    description1: null,
    description2: null,
    description3: null,
    messages: null,
    badge: null
};

SubModule.propTypes = {
    name: PropTypes.string.isRequired,
    link: PropTypes.string,
    badge: PropTypes.object,
    description1: PropTypes.object,
    description2: PropTypes.object,
    description3: PropTypes.object,
    messages: PropTypes.array,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    extLink: PropTypes.bool
};

export default SubModule;